import { useRef, useEffect, useState } from "react";
import Bugsnag from "@bugsnag/js";
import logger from "./logger";

function useDynamicSVGImport(name) {
  const ImportedIconRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const importIcon = async () => {
      try {
        ImportedIconRef.current = (
          await import(
            `../public/images/${process.env.NEXT_PUBLIC_CUSTOMER}/dynamic-svg/${name}.svg`
          )
        ).default;
      } catch (err) {
        Bugsnag.notify(new Error("Dynamic SVG missing"), (event) => {
          event.addMetadata("params", {
            svgName: name,
            customer: process.env.NEXT_PUBLIC_CUSTOMER,
            error: err?.message,
          });
        });
        logger.info("error while getting the svg! Check the name!");
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  return { loading, SvgComponent: ImportedIconRef.current };
}

export default useDynamicSVGImport;
